import React, { useState, useEffect } from "react";
import useStyles from "../../styles/companyProfileFormstyle";
import { Grid, Paper } from "@material-ui/core";
import UpdateAccountCardForm from "./UpdateAccountCardForm";
import AccountCardOnlyShow from "./AccountCardOnlyShow";
import ConfirmRemoveAccountButton from "./ConfirmRemoveAccountButton";

export const AccountContext = React.createContext({});
const AccountCard = (props) => {
  const classes = useStyles();
  const {
    accountID,
    imgLink,
    name,
    phone,
    email,
    role,
    roleId,
    company_name,
    lastLogin,
    activeStatus,
    otp_required,
    invisible_companies,
    password,
    companyID,
    getCompanyAccount,
  } = props;
  const [isEditAccount, setIsEditAccount] = useState(false);
  const [confirmRemoveDialogOpen, setConfirmRemoveDialogOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState();

  const handleEditAccount = () => {
    setIsEditAccount(true);
  };

  const handleCancelEditAccount = () => {
    setIsEditAccount(false);
  };

  const ShowConfirmRemoveAccountButton = async () => {
    setConfirmRemoveDialogOpen(true);
  };

  const handleCloseRemoveButton = () => {
    setConfirmRemoveDialogOpen(false);
  };

  useEffect(() => {
    setIsAdmin(role === "Administrator");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AccountContext.Provider value={{ handleCancelEditAccount }}>
      {!isEditAccount ? (
        <Grid
          item
          xl={3}
          lg={4}
          md={6}
          sm={12}
          xs={12}
          className={`${classes.accountCardShow} ${classes.accountCardWrap}`}
        >
          <Paper elevation={0} className={classes.paper}>
            {!confirmRemoveDialogOpen ? (
              <AccountCardOnlyShow
                id={accountID}
                name={name}
                phone={phone}
                email={email}
                lastLogin={lastLogin}
                activeStatus={activeStatus}
                otp_required={otp_required}
                avatarLink={imgLink}
                role={role}
                company_name={company_name}
                handleEditAccount={handleEditAccount}
                ShowConfirmRemoveAccountButton={ShowConfirmRemoveAccountButton}
                isAdmin={isAdmin}
              />
            ) : (
              <ConfirmRemoveAccountButton
                id={accountID}
                name={name}
                companyID={companyID}
                email={email}
                getCompanyAccount={getCompanyAccount}
                handleCloseRemoveButton={handleCloseRemoveButton}
              />
            )}
          </Paper>
        </Grid>
      ) : (
        <UpdateAccountCardForm
          id={accountID}
          name={name}
          phone={phone}
          email={email}
          activeStatus={activeStatus}
          otp_required={otp_required}
          invisible_companies={invisible_companies}
          avatarLink={imgLink}
          role={role}
          roleId={roleId}
          password={password}
          handleCancelCreateAccount={handleCancelEditAccount}
        />
      )}
    </AccountContext.Provider>
  );
};

export default AccountCard;
